import type { ReactNode } from 'react';

type NoticeProps = {
  children: ReactNode;
};

/** Plain-text informational line, e.g. the "solo dueño" redirect explanation. */
export function Notice({ children }: NoticeProps) {
  return (
    <p role="status" className="notice">
      {children}
    </p>
  );
}
